import styles from 'styles/GreetingScreen.module.css'
import Reveal from 'reveal.js'

import _ from 'lodash'

type GreetingScreenPropsType = {
  studentName: string;
  greetingText: string;
  mascot: string
}

function GreetingScreen({ studentName, greetingText, mascot }: GreetingScreenPropsType) {
  const formatedStudentName = _.toLower(studentName) === 'your child' ? '' : _.startCase(_.toLower(studentName))

  const displayName = (name: string) => {
    if(name === '') {
      return 'Hello!'
    } else {
      return (
        <>
          {greetingText}, <br/>{formatedStudentName}!
        </>
      )
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {displayName(formatedStudentName)}
      </div>
      <img
        src={mascot}
        alt='mascot'
        className={styles.image}
      />
      <div className={styles.button} onClick={()=>Reveal.next()}>
        START
      </div>
    </div>
  )
}

export default GreetingScreen
